import { Emoji } from '../emojiTypes';

export const DEFAULT_COLUMN_COUNT = 8;

export const PICKER_ROW_TYPES = {
    TITLE: 0,
    EMOJI: 1,
};

export const RECENT_CATEGORY_ID = 'Frequently used';

export type EmojiCategory = {
    name: string;
    localeKey: string;
    groups: string[];
};

export const CATEGORIES: EmojiCategory[] = [
    {
        name: 'Frequently used',
        localeKey: 'frequentlyUsed',
        groups: [RECENT_CATEGORY_ID],
    },
    {
        name: 'Smileys & Emotions',
        localeKey: 'smileysEmotions',
        groups: ['Smileys & Emotion'],
    },
    {
        name: 'People & Body',
        localeKey: 'peopleBody',
        groups: ['People & Body'],
    },
    {
        name: 'Animals & Nature',
        localeKey: 'animalsNature',
        groups: ['Animals & Nature'],
    },
    {
        name: 'Food & Drink',
        localeKey: 'foodDrink',
        groups: ['Food & Drink'],
    },
    {
        name: 'Travel & Places',
        localeKey: 'travelPlaces',
        groups: ['Travel & Places'],
    },
    {
        name: 'Activities',
        localeKey: 'activities',
        groups: ['Activities'],
    },
    {
        name: 'Objects',
        localeKey: 'objects',
        groups: ['Objects'],
    },
    {
        name: 'Symbols',
        localeKey: 'symbols',
        groups: ['Symbols'],
    },
    {
        name: 'Flags',
        localeKey: 'flags',
        groups: ['Flags'],
    },
];

export const SKIN_TONE_EMOJI_CODE = '1F44D';

export const RECENTLY_USED_DEFAULTS = {
    '1F44D': 4,
    '1F44E': 3,
    '1F60A': 2,
    '1F600': 2,
    '1F642': 1,
    '1F914': 1,
    '1F60D': 1,
    '1F61E': 1,
};

export type EmojiPopupContentProps = {
    gridSize: number;
    closePopup: () => void;
    selectedEmojiIds: string[];
    onSelectEmoji: (emojiCode: string, emoji?: Emoji) => void;
};
